'use client';

import { Carousel } from '@mantine/carousel';
import { Paper, useMatches } from '@mantine/core';

import '@mantine/carousel/styles.css';

export function BannerAd() {
  const bannerConfig = useMatches({
    base: {
      height: 'clamp(120px, 32vw, 180px)',
      images: [
        'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/low-price-mobile.png',
        'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/digital-health-platform-mobile.png',
      ],
    },
    sm: {
      height: 'clamp(315px, 26vw, 310px)',
      images: [
        'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/low-price-desktop.png',
        'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/digital-health-platform-desktop.png',
      ],
    },
    md: {
      height: 'clamp(400px, 30vw, 650px)',
      images: [
        'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/low-price-desktop.png',
        'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/digital-health-platform-desktop.png',
      ],
    },
  });

  const btnConfig = useMatches({
    base: {
      fontSize: 'clamp(8px, 2vw, 10px)',
      padding: 'clamp(3px, 0.8vw, 5px) clamp(8px, 1.5vw, 10px)',
      borderRadius: '3px',
      bottom: 'clamp(0.2rem, 0.1rem, 0.3rem)',
      left: 'clamp(10px, 2vw, 10px)',
      rippleInset: '-5px',
      rippleBorder: '1px',
    },
    sm: {
      fontSize: '12px',
      padding: '4px 14px',
      borderRadius: '5px',
      bottom: '7px',
      left: '26px',
      rippleInset: '-7px',
      rippleBorder: '1.5px',
    },
    md: {
      fontSize: '14px',
      padding: '8px 20px',
      borderRadius: '6px',
      bottom: '20px',
      left: '48px',
      rippleInset: '-10px',
      rippleBorder: '2px',
    },
  });

  const slides = bannerConfig.images ?? [];

  return (
    <>
      <style>{`
        .panakea-btn {
          position: relative;
          background: #1E4D8F;
          font-weight: 600;
          color: white;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          transition: background 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
          overflow: visible;
          cursor: pointer;
          border: none;
          display: inline-block;
          text-decoration: none;
          white-space: nowrap;
        }
        .panakea-btn::before,
        .panakea-btn::after {
          content: '';
          position: absolute;
          inset: 0;
          border-style: solid;
          border-color: #1E4D8F;
          border-width: var(--ripple-border);
          border-radius: var(--ripple-radius);
          opacity: 0;
          pointer-events: none;
          animation: ripple-out 1.2s ease-out infinite;
        }
        .panakea-btn::after {
          animation-delay: 0.4s;
        }
        .panakea-btn:hover {
          background: #163E73;
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 6px 20px rgba(30, 77, 143, 0.4);
        }
        .panakea-btn:active {
          transform: scale(0.95);
        }
        @keyframes ripple-out {
          0% {
            inset: 0px;
            opacity: 0.8;
          }
          100% {
            inset: var(--ripple-inset);
            opacity: 0;
          }
        }
      `}</style>

      <Carousel
        withIndicators
        height={bannerConfig.height}
        w="100%"
        slideSize="100%"
        slideGap="md"
        emblaOptions={{
          loop: true,
        }}
        classNames={{
          indicator: 'bg-white/50 data-[active]:bg-white',
          control: 'bg-white/20 hover:bg-white/40 text-white border-none',
        }}
      >
        {slides.map((image, index) => {
          const digitalHealthBanners = [
            'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/digital-health-platform-desktop.png',
            'https://storage.googleapis.com/izmo-production/healthyone-marketplace/banner/digital-health-platform-mobile.png',
          ];

          const isDigitalHealthBanner = digitalHealthBanners.includes(image);

          return (
            <Carousel.Slide key={index}>
              <Paper
                radius="md"
                className="relative h-full w-full overflow-hidden"
              >
                <img
                  src={image}
                  alt={`Banner ${index + 1}`}
                  className="h-full w-full object-cover"
                />

                {isDigitalHealthBanner && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: btnConfig.bottom,
                      left: btnConfig.left,
                    }}
                  >
                    <a
                      href="https://virtue.panakea.id/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="panakea-btn"
                      style={
                        {
                          fontSize: btnConfig.fontSize,
                          padding: btnConfig.padding,
                          borderRadius: btnConfig.borderRadius,
                          '--ripple-inset': btnConfig.rippleInset,
                          '--ripple-border': btnConfig.rippleBorder,
                          '--ripple-radius': btnConfig.borderRadius,
                        } as React.CSSProperties
                      }
                    >
                      Kunjungi Sekarang
                    </a>
                  </div>
                )}
              </Paper>
            </Carousel.Slide>
          );
        })}
      </Carousel>
    </>
  );
}
